import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

const getGamezoneBannerState = (state: IStore) => state.gamezoneBaner;

export const getGamezoneBanerData = createSelector(getGamezoneBannerState, (state) => state.banner);
export const getGamezoneLevel = createSelector(getGamezoneBannerState, (state) => state.level);
